export const CUSTOM_VIEW = 'CUSTOM_VIEW';